// extracted by mini-css-extract-plugin
export default {"Pagehead":"YourSponsorships-module__Pagehead--Wsbqj","Text":"YourSponsorships-module__Text--ygrLW","UnderlineNav":"YourSponsorships-module__UnderlineNav--PR4gQ"};